import { render, staticRenderFns } from "./VariableSelect.vue?vue&type=template&id=70110e64&"
import script from "./VariableSelect.vue?vue&type=script&lang=ts&"
export * from "./VariableSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports